module.exports = __webpack_public_path__ + "img/exam_7.33194518.png";